import * as z from "zod";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
  maxCharacters: (num) => `Máximo de ${num} caracteres`,
  exactCharacters: (num) => `Deve conter ${num} caracteres`,
  invalidUrl: "Link inválido",
};

const NotificationTypeValidator = {
  display_name: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
};

export default NotificationTypeValidator;
